import axios from '../components/UtilityHelpers/AxiosHelper';
import { AxiosResponse } from 'axios';
import { useAuth } from './useAuth';


interface UserData {
    roles: string[];
    email: string;
    firstName: string;
    lastName: string;
    upi: string;
    userID: string;
    notification_type: number;
}

interface RefreshResponseData {
    user: UserData;
    accessToken: string;
}

const useRefreshToken = (): (() => Promise<string>) => {
    const auth = useAuth();

    const refresh = async (): Promise<string> => {

        const csrfToken = auth?.authService.getCookie('csrf_access_token');
        if (!csrfToken) throw new Error('CSRF access token cookie not found');

        const response: AxiosResponse<RefreshResponseData> = await axios.get<RefreshResponseData>('refresh', {
            withCredentials: true,
            headers: {
                'X-CSRF-TOKEN': csrfToken,
            }
        });

        auth?.setAccessToken(response.data.accessToken);
        auth?.setRoles(response.data.user.roles);
        auth?.setEmail(response.data.user.email);
        auth?.setFirstName(response.data.user.firstName);
        auth?.setLastName(response.data.user.lastName);
        auth?.setNotificationType(response.data.user.notification_type)
        auth?.setUpi(response.data.user.upi);
    
        return response.data.accessToken;
    }

    return refresh;
};

export default useRefreshToken;